<template>
  <div class="container" id="cont">
    <!-- Tabs sit on top of the box -->
    <nav class="tabs is-boxed tabs-on-card">
      <ul>
        <li
          v-bind:class="{ 'is-active': stepGraphic == 1 }"
          @click="changeTab(1)"
        >
          <a href="javascript:void(0)">
            <span class="icon is-small">
              <i class="material-icons">low_priority</i>
            </span>
            <span class="is-hidden-mobile">Priorización</span>
          </a>
        </li>
        <li
          v-bind:class="{ 'is-active': stepGraphic == 2 }"
          @click="changeTab(2)"
        >
          <a href="javascript:void(0)">
            <span class="icon is-small">
              <i class="material-icons">bar_chart</i>
            </span>
            <span class="is-hidden-mobile">Distribución</span>
          </a>
        </li>
        <li
          v-bind:class="{ 'is-active': stepGraphic == 4 }"
          @click="changeTab(4)"
        >
          <a href="javascript:void(0)">
            <span class="icon is-small">
              <i class="material-icons">compare_arrows</i>
            </span>
            <span class="is-hidden-mobile">Comparativo</span>
          </a>
        </li>
        <li
          v-if="!this.$route.params.id && hasComparativo"
          v-bind:class="{ 'is-active': stepGraphic == 5 }"
          @click="changeTab(5)"
        >
          <a href="javascript:void(0)">
            <span class="icon is-small">
              <i class="material-icons">trending_up</i>
            </span>
            <span class="is-hidden-mobile">Evolución</span>
          </a>
        </li>
        <li
          v-if="!this.$route.params.id && tokenUser && (tokenUser.admin || tokenUser.cliente)"
          v-bind:class="{
            'is-active': stepGraphic == 3,
            disabled: validCtx,
          }"
          @click="!validCtx && changeTab(3)"
        >
          <a href="javascript:void(0)">
            <span class="icon is-small">
              <img src="@/assets/icons/ranking-linear.svg" alt="benchmark" />
            </span>
            <span class="is-hidden-mobile">Benchmark</span>
          </a>
        </li>
      </ul>
    </nav>
    <div class="box">
      <!-- Graphics - Prioritization & Detail -->
      <div>
        <Transition name="fade">
          <Prioritization
            v-if="stepGraphic == 1"
            :summary="summary"
            :namevars="namevars"
            :nombrerangos="nombrerangos"
            :rangos="rangos"
            :info-process="infoProcess"
            :change="change"
            :name-results="nameResults"
            @open-menu-inter="openMenuInter"
          />
        </Transition>
        <Transition name="fade">
          <Distribution
            v-if="stepGraphic == 2"
            :summary="summary"
            :namevars="namevars"
            :change="change"
            :rangos="rangos"
            :name-results="nameResults"
            :detail-data="detailData"
            @switch-sub-groups="switchSubGroups"
            @open-menu-inter="openMenuInter"
          />
        </Transition>
        <Transition name="fade">
          <Benchmark
            v-if="stepGraphic == 3"
            :summary="summary"
            :namevars="namevars"
            :change="change"
            :rangos="rangos"
            :name-results="nameResults"
            :detail-data="detailData"
            :general-context="generalContext"
            :proceso="proceso"
            @switch-sub-groups="switchSubGroups"
            @open-menu-inter="openMenuInter"
          />
        </Transition>
        <Transition name="fade">
          <!-- Comparativo: min-height para que el dropdown de los
               b-autocomplete (Grupo A/B) tenga espacio de sobra para
               desplegar su lista hacia abajo, incluso antes de seleccionar
               ambos grupos (cuando el contenido del tab es más corto). -->
          <div
            v-if="stepGraphic == 4"
            style="margin-top: 15px; min-height: 420px;"
          >
            <GroupComparison
              :groups="groupsAll"
              :proceso="proceso"
              :namevars="namevars"
              :nombrerangos="nombrerangos"
              :rangos="rangos"
              :process-values-cal="processValuesCal"
              :summary-total="summaryTotal"
              :info-process-total="infoProcessTotal"
            />
          </div>
        </Transition>
        <Transition name="fade">
          <Evolution
            v-if="stepGraphic == 5"
            :summary="summary"
            :rangos="rangos"
            :nombrerangos="nombrerangos"
          />
        </Transition>
      </div>
      <!-- Table Groups: no aplica en el tab Comparativo (tiene su propio
           selector de grupos) ni en Evolución (no usa la tabla de subgrupos). -->
      <div
        v-if="!this.$route.params.id && groups.length && stepGraphic != 4 && stepGraphic != 5"
        style="margin-top: 50px"
        class="is-flex is-justify-center"
      >
        <hr class="has-text-dark" style="width: 20%" />
        <h1
          class="title is-size-4"
          style="margin-top: 10px; margin-right: 15px; margin-left: 15px"
        >
          Prioridad de Intervención en subgrupos
        </h1>
        <hr class="has-text-dark" style="width: 20%" />
      </div>
      <div v-if="!this.$route.params.id && stepGraphic != 4 && stepGraphic != 5">
        <table-groups
          ref="tableClima"
          v-if="groups.length"
          :get-range="rangos"
          :datos="groups"
          :filters="selectedFilterRows"
          :limitSelection="groups.length"
          :nameQuadrants="namevars"
          :nameRanges="nombrerangos"
          @setFilterTable="setFilterTable"
          @copyLink="copyLink"
        ></table-groups>
      </div>
    </div>
    <!-- Buttons -->
    <div
      v-if="!this.$route.params.id"
      v-on:click="section"
      class="button is-dark"
      style="margin-top: 20px; margin-right: 10px"
    >
      <span style="margin-right: 5px">{{
        showSection ? "Ocultar detalles" : "Ver detalles"
      }}</span>
      <span class="icon"
        ><i class="material-icons is-size-1">{{
          showSection ? "arrow_drop_up" : "arrow_drop_down"
        }}</i></span
      >
    </div>
    <div v-on:click="goToGuie" class="button is-dark" style="margin-top: 20px;">
      <span style="margin-right: 5px">Ver guía</span>
      <span class="icon"><i class="material-icons">local_library</i></span>
    </div>
    <!-- Comments: tampoco aplica en el tab Comparativo. -->
    <div
      v-if="!this.$route.params.id && comments.length > 5 && stepGraphic != 4"
      style="margin-top: 60px !important"
    >
      <div style="margin-bottom: 40px;" class="is-flex is-justify-center">
        <hr class="has-text-dark" style="width: 20%" />
        <h1
          class="title is-size-4"
          style="margin-top: 10px; margin-right: 15px; margin-left: 15px"
        >
          Comentarios
        </h1>
        <hr class="has-text-dark" style="width: 20%" />
      </div>
      <br />
      <div
        style="height: 330px !important; overflow-y: scroll;"
        class="container"
      >
        <div class="box">
          <div v-for="(c, index) in comments" :key="index">
            <div>
              <div v-if="c.responses.comentarios">
                <article class="media" style="padding-bottom: 15px">
                  <figure class="media-left">
                    <p class="image">
                      <i class="material-icons is-size-1">account_box</i>
                    </p>
                  </figure>
                  <div class="media-content">
                    <div class="content">
                      <p>
                        <strong>Anónimo</strong>
                        <br />
                        {{ c ? c.responses.comentarios : "" }}
                      </p>
                    </div>
                    <!-- <nav class="level is-mobile">
                      <div class="level-left">
                        <a class="level-item">
                          <span class="icon is-small"><i class="fas fa-reply"></i></span>
                        </a>
                        <a class="level-item">
                          <span class="icon is-small"><i class="fas fa-retweet"></i></span>
                        </a>
                        <a class="level-item">
                          <span class="icon is-small"><i class="fas fa-heart"></i></span>
                        </a>
                      </div>
                    </nav> -->
                  </div>
                </article>
              </div>
            </div>
            <br />
          </div>
        </div>
      </div>
    </div>
    <transition name="slide-panel">
      <menu-interpretacion
        v-if="menuInter.showInter"
        :data="menuInter.data"
        :type="menuInter.type"
        @closeMenuInter="closeMenuInter"
      ></menu-interpretacion>
    </transition>
  </div>
</template>

<script>
import apiServices from "@/services/yungol-services";
import tableGroups from "./TableGroups.vue";
import menuInterpretacion from "./components/menuInterpretacion.vue";
import { mapState } from "vuex";
import Prioritization from "./components/tabs/Prioritization.vue";
import Distribution from "./components/tabs/Distribution.vue";
import Benchmark from "./components/tabs/Benchmark.vue";
import GroupComparison from "./components/tabs/GroupComparison.vue";
import Evolution from "./components/tabs/Evolution.vue";

export default {
  data() {
    return {
      loader: false,
      widthdiv: 0,
      namevars: {
        apsd: "Social",
        vincd: "Compromiso",
        apod: "Organizacional",
        autd: "Autonomía",
        agid: "Agilidad",
        mejd: "Mejora",
        excd: "Excelencia",
        cycd: "Claridad",
        segd: "Seguridad",
        logrd: "Logro",
        servd: "Servicio",
        repd: "Reputación",
        lidd: "Liderazgo",
        engad: "Engagement",
        recd: "Recursos",
        compd: "Compensación",
        CClimad: "Toda la Organización",
        dimenc: "Dimensiones Centrales",
        engag: "Engagement",
        apoyod: "Apoyo",
        innovaciond: "Innovación",
        calidadd: "Calidad",
        metasd: "Metas",
      },
      nombrerangos: {
        1: "Sigamos así",
        2: "Vamos bien",
        3: "Estamos cerca",
        4: "Cuidado",
        5: "Necesita atención pronto",
        6: "Actuemos ya",
        0: "N/A",
      },
      comments: {},
      summary: {},
      detailSummary: {
        CClimad: {
          apoyod: {
            data: ["apsd", "vincd", "apod"],
            active: false,
          },
          innovaciond: {
            data: ["autd", "agid", "mejd"],
            active: false,
          },
          calidadd: {
            data: ["excd", "cycd", "segd"],
            active: false,
          },
          metasd: {
            data: ["logrd", "servd", "repd"],
            active: false,
          },
          dimenc: {
            data: ["lidd", "recd", "compd"],
            active: false,
            unique: true,
          },
          engag: {
            data: ["engad"],
            active: false,
            unique: true,
            group: "dimenc",
          },
        },
      },
      groups: [],
      groupsAll: [],
      infoProcess: {},
      selected: {
        filters: {},
      },
      change: 0,
      menuInter: {
        showInter: false,
        data: null,
        type: 0,
      },
      stepGraphic: 1,
    };
  },
  computed: {
    ...mapState(["windowwidth", "isOculto", "empresa", "tokenUser"]),
    detailData() {
      return this.detailSummary;
    },
    hasComparativo() {
      return !!(
        this.proceso &&
        this.proceso.historic &&
        this.proceso.historic.length > 0
      );
    },
    // Filtros activos como filas { group, name } para volver a marcar las
    // casillas tras recargar la tabla filtrada.
    selectedFilterRows() {
      const rows = [];
      const filters = this.selected.filters || {};
      for (const g of Object.keys(filters)) {
        for (const sg of filters[g]) rows.push({ group: g, name: sg });
      }
      return rows;
    },
  },
  props: {
    proceso: {
      type: Object,
    },
    showSection: Boolean,
    processValuesCal: {
      type: Function,
      required: true,
    },
    summaryTotal: {
      type: Object,
      required: true,
    },
    infoProcessTotal: {
      type: Object,
      required: true,
    },
    generalContext: {
      type: Object,
      required: true,
    },
    validCtx: {
      type: Boolean,
      required: true,
    },
  },
  beforeMount() {
    this.configSummary();
    // console.log("summary", this.summary);
  },
  methods: {
    async findSummary() {
      try {
        const query = {
          filters: this.selected.filters,
          proceso: this.proceso._id,
        };
        let result = await apiServices.post(`/traecalculoclima`, query);
        if (result.data) {
          if (this.proceso.processComp) {
            const resultComp = await apiServices.post(`/traecalculoclima`, {
              filters: this.selected.filters,
              proceso: this.proceso.processComp._id,
            });
            result.data.calculos.processComp = this.processValuesCal(
              resultComp.data.calculos,
            );
            result.data.calculos.processComp.nombre = this.proceso.processComp.nombre;
          }
          this.infoProcess = result.data.infoProcess;
          this.summary = this.processValuesCal(result.data.calculos);
          this.change = this.change ? 0 : 1;
        }
      } catch (err) {
        console.log(err);
      }
    },
    async getGroups() {
      const result = await apiServices.post(`/traegruposclima`, {
        proceso: this.proceso._id,
        // Filtra la tabla por la selección (recalcula los demás grupos sobre la
        // subpoblación seleccionada), igual que en FRP.
        filters: this.selected.filters,
      });
      this.groups = result.data;
      // Snapshot sin filtrar para el selector de Comparativo de grupos: no debe
      // encogerse cuando se filtra la tabla de "Prioridad de intervención".
      if (!Object.keys(this.selected.filters).length) {
        this.groupsAll = result.data;
      }
    },
    async findComments() {
      try {
        const result = await apiServices.post(
          `/listcommentsclima/${this.proceso._id}`,
          { filter: this.selected.filters },
        );
        if (result.data.length > 4) {
          this.comments = result.data;
        } else {
          this.comments = {};
        }
      } catch (err) {
        console.log(err);
      }
    },
    configSummary() {
      this.summary = this.summaryTotal;
      if (this.summaryTotal.filters) {
        this.selected.filters = this.summaryTotal.filters;
      }
      if (this.summaryTotal.infoProcess) {
        this.infoProcess = this.summaryTotal.infoProcess;
      }
    },
    openMenuInter(w) {
      this.menuInter.data = w;
      this.menuInter.type = w.type;
      this.menuInter.showInter = true;
    },
    closeMenuInter() {
      this.menuInter.showInter = false;
    },
    // filtro
    setFilterTable(data) {
      if (data.length) {
        const filters = {};
        data.map((x) => {
          const g = x.group;
          const sg = x.name;
          if (filters[g]) {
            filters[g].push(sg);
          } else {
            filters[g] = [sg];
          }
        });
        this.selected.filters = filters;
      } else {
        this.selected.filters = {};
      }
    },
    deselectFilter() {
      this.$refs.tableClima.deselect();
    },
    deselectOne(filter) {
      // Validar si será necesario utilizarlo y organizarlo
      this.$refs.tableClima.deselectOne([filter]);
    },
    // Others
    async copyLink(filter = null) {
      let textArea = document.createElement("textarea");

      textArea.style.position = "fixed";
      textArea.style.top = 0;
      textArea.style.left = 0;

      // Ensure it has a small width and height. Setting to 1px / 1em
      // doesn't work as this gives a negative w/h on some browsers.
      textArea.style.width = "2em";
      textArea.style.height = "2em";

      // We don't need padding, reducing the size if it does flash render.
      textArea.style.padding = 0;

      // Clean up any borders.
      textArea.style.border = "none";
      textArea.style.outline = "none";
      textArea.style.boxShadow = "none";

      // Avoid flash of the white box if rendered for any reason.
      textArea.style.background = "transparent";

      let data = {};
      const allFilters = this.selected.filters;
      filter = filter ? JSON.stringify(filter) : JSON.stringify(allFilters);

      const encodeFilter = btoa(filter); // Para descifrarlo es con atob()

      data.process = this.proceso._id;
      data.filter = btoa(encodeFilter); // Se vuelve a cifrar

      textArea.value =
        window.location.host +
        "/shareClima/" +
        data.process +
        "/" +
        data.filter;

      document.body.appendChild(textArea);
      textArea.focus();
      textArea.select();

      try {
        let successful = document.execCommand("copy");
        let msg = successful ? "¡Copiado al portapapeles!" : "Error al copiar";
        let type = successful ? "is-link" : "is-danger";

        this.$store.dispatch("notify", {
          message: msg,
          type: type,
        });
      } catch (err) {
        this.$store.dispatch("notify", {
          message: "Error al copiar",
          type: "is-danger",
        });
      }
      document.body.removeChild(textArea);
    },
    nameResults() {
      let texto = "Toda la organización";
      if (Object.keys(this.selected.filters).length === 1) {
        if (
          this.selected.filters[Object.keys(this.selected.filters)[0]].length >
          1
        ) {
          let grupo = Object.keys(this.selected.filters);
          texto = "Varios filtros de " + grupo;
        } else {
          let grupo = Object.keys(this.selected.filters);
          let subrupo = this.selected.filters[
            Object.keys(this.selected.filters)
          ][0];
          texto = grupo + " " + subrupo;
        }
      } else if (Object.keys(this.selected.filters).length > 1) {
        texto = "Varios filtros aplicados";
      }
      return texto;
    },
    changeTab(value) {
      this.stepGraphic = value;
      // Las gráficas de la pestaña recién activada pudieron omitir el redibujo
      // mientras estaban ocultas; forzamos un resize para que se ajusten al
      // contenedor una vez visibles.
      this.$nextTick(() => {
        window.dispatchEvent(new Event("resize"));
      });
    },
    section() {
      this.$emit("section");
    },
    goToGuie() {
      this.$emit("goToGuie");
    },
    calculaanchodediv() {
      this.widthdiv = document.getElementById("cont").clientWidth;
    },
    switchSubGroups(g) {
      this.detailSummary.CClimad[g].active = !this.detailSummary.CClimad[g]
        .active;
    },
    rangos(n) {
      let returned;

      if (n === 0) {
        returned = 6;
      } else if (isNaN(n)) {
        returned = 0;
      } else if (n >= 84) {
        returned = 1; // Sigamos así
      } else if (n >= 70) {
        returned = 2; // Vamos bien
      } else if (n >= 50) {
        returned = 3; // Estamos cerca
      } else if (n >= 30) {
        returned = 4; // Cuidado
      } else if (n >= 16) {
        returned = 5; // Necesita atención pronto
      } else {
        returned = 6; // Actuemos ya
      }

      return returned;
    },
  },
  mounted() {
    this.calculaanchodediv();
  },
  async created() {
    await this.getGroups();
    await this.findComments();
  },
  watch: {
    windowwidth(nv, ov) {
      this.calculaanchodediv();
    },
    "selected.filters": {
      deep: true,
      handler: function(nv) {
        // Notifica al padre (Resultadosclima) para que muestre la sección de
        // filtros activos fija arriba, junto a la leyenda.
        this.$emit("filtersChanged", nv);
        // NOT consult if the route get of param id
        if (!this.$route.params.id) {
          // Recalcula la tabla de grupos sobre la subpoblación seleccionada.
          this.getGroups();
          if (Object.keys(nv).length) {
            this.findSummary();
            this.findComments();
          } else {
            this.summary = this.summaryTotal;
            this.change = this.change ? 0 : 1;
            this.infoProcess = {};
            this.findComments();
          }
        }
      },
    },
  },
  components: {
    tableGroups,
    menuInterpretacion,
    Prioritization,
    Distribution,
    Benchmark,
    GroupComparison,
    Evolution,
  },
  errorCaptured(err, vm, info) {
    console.log({ err, vm, info });
    /* this.$store.dispatch("notify", {
      message: `Hubo un error al cargar el Tablero, intenta de nuevo o reporta este error`,
      type: "is-danger",
    }); */
  },
};
</script>

<style lang="scss" scoped>
.box {
  padding: 2.5rem 4rem;
}

.div-table {
  @media (min-width: 769px) {
    overflow-y: hidden !important;
  }
  @media (max-width: 768px) {
    overflow-x: scroll !important;
    overflow-y: scroll !important;
  }
}

.options {
  background-color: white;
  box-shadow: 0px 6px 28px -18px black;
  position: absolute;
  width: 57.5%;
  z-index: 35;
}

/* Table */

.heat-table {
  border: 1px solid #c2c2c2;
}

.heat-table thead {
  border: 1px solid #dbdbdb;
}

.heat-table tbody {
  border: 1px solid #dbdbdb;
}

.heat-table th {
  border: 1px solid #dbdbdb;
}

.heat-table td {
  border: 1px solid #dbdbdb;
}

.scroll-table {
  height: 306px;
  overflow-y: auto;
  overflow-x: auto;
}

.head-stick th {
  background: white;
  position: sticky;
  top: -3px; /* Don't forget this, required for the stickiness */
  box-shadow: 0 2px 2px -1px rgba(0, 0, 0, 0.4);
  z-index: 60 !important;
}

.bloque1 {
  background-color: var(--clima-1);
  box-shadow: 2px 2px 4px 1px rgba(0, 0, 0, 0.2);
}

.bloque2 {
  background-color: #e9e9e9;
  border-style: solid;
  border-color: #c2c2c2;
}

.bloque3 {
  border-width: 5px;
  border-style: solid;
  border-color: #fae900;
}

.bloque4 {
  border-width: 5px;
  border-style: solid;
  border-color: #ff226b;
}

.bloque0 {
  border-width: 5px;
  border-style: solid;
  border-color: #a5a5a5;
}

.tooltipCustom {
  position: absolute;
  background: rgba(0, 0, 0, 0.9);
  color: white;
  border-radius: 3px;
  -webkit-transition: all 0.1s ease;
  transition: all 0.1s ease;
  //pointer-events: none;
  padding: 10px;
  font-size: 12px;
  min-width: 260px;
  max-width: 360px;
  max-height: 310px !important;
  overflow-y: scroll !important;
  z-index: 9999;
  font-family: "Helvetica Neue", "Helvetica", "Arial", sans-serif;
  display: none;
  opacity: 0;
}

// Tab

.tabs-on-card {
  margin-bottom: 0 !important;
  padding-left: 2rem;
  position: relative;
  z-index: 2;
}

.tabs-on-card ul {
  border-bottom: none !important;
}

.tabs-on-card.is-boxed li {
  border-bottom: none;
}

.tabs-on-card.is-boxed li a {
  border: 1px solid #dbdbdb !important;
  border-bottom: none !important;
  border-radius: 6px 6px 0 0 !important;
  background-color: #f5f5f5;
  color: #4a4a4a;
  padding-bottom: calc(0.5em + 1px);
  transition: background-color 0.15s ease, color 0.15s ease;
}

.tabs-on-card.is-boxed li a:hover {
  background-color: #ececec;
  color: #363636;
}

.tabs-on-card.is-boxed li.is-active a {
  background-color: white;
  border-color: #dbdbdb !important;
  color: #522687;
  font-weight: 600;
  position: relative;
  z-index: 2;
}

.tabs-on-card.is-boxed li.disabled {
  pointer-events: none;
  opacity: 0.5;
}

.tabs-on-card.is-boxed li.disabled a {
  background-color: #f5f5f5;
  color: #7a7a7a;
}

.tabs-on-card.is-boxed li a .icon {
  margin-right: 0.4em;
}

.tabs-on-card.is-boxed li a .icon .material-icons {
  font-size: 18px;
}

.tabs-on-card.is-boxed li a .icon img {
  width: 18px;
  height: 18px;
}

@media (max-width: 768px) {
  // Tabs: sin padding lateral y sólo iconos (labels ocultos con is-hidden-mobile)
  .tabs-on-card {
    padding-left: 0;
  }

  .tabs-on-card ul {
    justify-content: space-around;
  }

  .tabs-on-card.is-boxed li {
    flex: 1;
  }

  .tabs-on-card.is-boxed li a {
    justify-content: center;
    padding-left: 0.75em;
    padding-right: 0.75em;
  }

  .tabs-on-card.is-boxed li a .icon {
    margin-right: 0;
  }

  // Menos padding en el box general
  .box {
    padding: 1.25rem 0.75rem;
  }

  .title.is-size-4 {
    font-size: 1rem !important;
    margin-right: 8px !important;
    margin-left: 8px !important;
    text-align: center;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/climan/ResultadosDetallado.vue